import React, { useEffect } from "react";

export default function Page({ title, children }) {
  useEffect(() => {
    document.title = `Larch - ${title}`;
  }, [title]);

  return <>{children}</>;
}
